module.exports = __webpack_public_path__ + "static/media/main_bg_samsung.bb65755a.jpg";